import { render, staticRenderFns } from "./ImportTablePanel.vue?vue&type=template&id=20bcfff3"
import script from "./ImportTablePanel.vue?vue&type=script&lang=js"
export * from "./ImportTablePanel.vue?vue&type=script&lang=js"
import style0 from "./ImportTablePanel.vue?vue&type=style&index=0&id=20bcfff3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports